module.exports = __webpack_public_path__ + "static/img/30007 (2).47588d0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30007 (2).webp
// module id = 6cac
// module chunks = 14